(() => {
  const toggle = document.querySelector("[data-menu-toggle]");
  const body = document.body;
  toggle?.addEventListener("click", () => {
    const open = body.classList.toggle("nav-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  });

  document.querySelectorAll("[data-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelector("[data-minus]")?.addEventListener("click", () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    wrap.querySelector("[data-plus]")?.addEventListener("click", () => {
      input.value = Number(input.value || 1) + 1;
    });
  });


  const keep = document.querySelector("[data-keep-shopping]");
  if (keep) {
    try {
      const ref = document.referrer;
      if (ref && new URL(ref).origin === location.origin && !ref.includes("/products/")) {
        keep.setAttribute("href", ref);
      }
    } catch (_) {}
  }

  const updateCartCount = (count) => {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      if (count > 0) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  };

  document.addEventListener("click", async (event) => {
    const btn = event.target.closest("[data-quick-add]");
    if (!btn) return;
    event.preventDefault();
    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId || btn.disabled) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding…";
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error("add failed");
      const cart = await fetch("/cart.js").then((r) => r.json());
      updateCartCount(cart.item_count || 0);
      btn.textContent = "Added";
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1200);
    } catch (_) {
      btn.textContent = "Try again";
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1500);
    }
  });

  const appBar = document.querySelector("[data-app-banner-bar]");
  if (appBar) {
    const key = "gcgypsey_app_banner_hidden";
    if (sessionStorage.getItem(key) === "1") {
      appBar.hidden = true;
    } else {
      window.setTimeout(() => {
        appBar.classList.add("is-hiding");
        window.setTimeout(() => {
          appBar.hidden = true;
          sessionStorage.setItem(key, "1");
        }, 400);
      }, 60000);
    }
  }

})();